export default __webpack_public_path__ + "fonts/merriweather400.woff2";